import React, { Component } from 'react';
import { Card, CardBody, CardHeader, Button, Alert, CardText, ListGroup, ListGroupItem } from 'reactstrap';
import IntlMessages from 'util/IntlMessages';
import Duplicates from './Duplicates';

class Types extends Component {
	constructor(props) {
		super(props);
		this.state = {
			containerWidth: 0,
			types: []
		};
		this.containerRef = {};
	}

	componentDidMount() {
		this.setState({ containerWidth: this.containerRef.clientWidth });
		this.props.getTypesByLocation(this.props.selectedPosition);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.windowWidth !== this.props.windowWidth) this.setState({ containerWidth: this.containerRef.clientWidth });
	}

	getColWidth() {
		if (this.state.containerWidth < 550) return 4;
		if (this.state.containerWidth < 800) return 3;
		if (this.state.containerWidth < 1000) return 2;
	}

	render() {
		const { colors, modules, organisationTypes } = this.props.settings;
		let { types } = this.props.settings;
		// Types auf die Organisation setzen wenn diese als organisationKey vorhanden ist damit das Formular drüberliegende
		// Orte von der Position her nicht benutzt sondern die Kategorien der Oragnisation
		if (this.props.organisationKey != 'leanact' && this.props.organisationKey != '') {
			types = organisationTypes;
		}
		return (
			<div className="row">
				<div className={modules.reportDuplicates ? 'col-lg-8 col-md-12' : 'col-lg-12 col-md-12'}>
					<Card>
						<CardHeader className="custom-main">
							<IntlMessages id="meldooWeb.newReport.type.title" />
						</CardHeader>
						<CardBody className="pb-0">
							<div ref={ref => (this.containerRef = ref)}>
								{this.props.windowWidth < 400 ? (
									<div className="w-100 pb-4">
										<ListGroup>
											{types.map(type => (
												<ListGroupItem
													action
													key={type.id}
													onClick={() => this.props.onSelectType(type.id)}
													className="d-flex align-items-center pointer"
												>
													<img src={type.iconURL} height={30} className="mr-3" />
													{type.name}
													{this.props.selectedType === type.id && <i className="zmdi zmdi-check zmdi-hc-2x ml-auto" />}
												</ListGroupItem>
											))}
										</ListGroup>
									</div>
								) : (
									<div className="row justify-content-center">
										{types.map(type => (
											<div className={`px-1 col-${this.getColWidth()}`} key={type.id}>
												<Card
													className={`p-2 jr-card-full-height pointer ${
														this.props.selectedType === type.id ? 'border-2 border-main' : ''
													}`}
													onClick={() => this.props.onSelectType(type.id)}
												>
													<div className="text-center">
														<img src={type.iconURL} className="w-50" />
													</div>
													<CardBody className="px-0 pb-0 pt-4 text-center">
														<CardText>{type.name}</CardText>
													</CardBody>
												</Card>
											</div>
										))}
									</div>
								)}
							</div>
						</CardBody>
					</Card>
					<Alert className="border custom-error" isOpen={this.props.errorMessages.type}>
						<IntlMessages id="meldooWeb.newReport.errors.type" />
					</Alert>
					<div className="d-flex w-100 justify-content-between">
						<Button color="default" className="jr-btn jr-btn-default custom-previous" onClick={this.props.onPreviousStep}>
							<i className="zmdi zmdi-chevron-left zmdi-hc-lg" />
							<IntlMessages id="meldooWeb.newReport.previousStep" />
						</Button>
						<Button
							color="default"
							className="jr-btn jr-btn-default custom-next"
							onClick={this.props.onNextStep}
							disabled={!this.props.selectedType}
						>
							<IntlMessages id="meldooWeb.newReport.nextStep" />
							<i className="zmdi zmdi-chevron-right zmdi-hc-lg" />
						</Button>
					</div>
				</div>
				{modules.reportDuplicates && (
					<div className="col-lg-4 col-md-12">
						<Duplicates duplicates={this.props.duplicates} colors={colors} toReport={this.props.toReport} />
					</div>
				)}
			</div>
		);
	}
}

export default Types;



// WEBPACK FOOTER //
// ./containers/MeldooWeb/Pages/NewReport/Component/Types.js